import { Button } from "@components";
import ReactGA from "react-ga4";

export default function ImpactReport() {
    const handleReadReport = () => {
        // Get additional context data
        const isMobile = window.innerWidth < 768;
        const userAgent = navigator.userAgent;
        const timestamp = new Date().toISOString();
        
        // Track the button click event with comprehensive data
        ReactGA.event({
            category: 'Impact Report',
            action: 'Download Report',
            label: '2025 Impact Report PDF',
            value: 1,
            // Custom parameters for detailed analysis
            custom_map: {
                'page_section': 'About Page',
                'content_type': 'PDF Report',
                'report_year': '2025',
                'device_type': isMobile ? 'Mobile' : 'Desktop',
                'interaction_type': 'Button Click',
                'user_agent': userAgent,
                'timestamp': timestamp,
                'page_url': window.location.href,
                'referrer': document.referrer || 'Direct'
            }
        });
        
        // Also track as a conversion event (optional)
        ReactGA.event({
            category: 'Conversions',
            action: 'Report Download',
            label: 'Impact Report 2025',
            value: 1
        });
        
        window.open('https://ctrees-website.s3.us-west-2.amazonaws.com/website_images/CTrees-Impact-Report-2025.pdf', '_blank');
    };

    return (
        <div className="w-full mb-20">
            {/* DESKTOP */}
            <div className="hidden md:block">
                {/* Gray background box */}
                <div className="mx-10 rounded-lg p-8 md:p-12" style={{ backgroundColor: '#E4E4E4' }}>
                    <div className="flex flex-row items-start gap-8">
                        {/* Image section - 1/3 width */}
                        <div className="w-1/3 flex justify-start">
                            <div className="relative cursor-pointer" onClick={handleReadReport}>
                                <img 
                                    src="https://ctrees-website.s3.us-west-2.amazonaws.com/website_images/impact2025_cover.png"
                                    alt="CTrees 2025 Impact Report Cover"
                                    className="w-full max-w-xs h-auto rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200"
                                />
                            </div>
                        </div>
                        
                        {/* Text section - 2/3 width */}
                        <div className="w-2/3 flex flex-col justify-center">
                            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">
                                2025 Impact Report
                            </h2>
                            
                            <p className="text-2xl text-black mb-6">
                                This report highlights CTrees institutional achievements in the following areas:
                            </p>
                            
                            <ul className="text-2xl text-black mb-8 space-y-2">
                                <li className="flex items-start">
                                    <span className="mr-3 text-black">•</span>
                                    Driving innovation in carbon markets
                                </li>
                                <li className="flex items-start">
                                    <span className="mr-3 text-black">•</span>
                                    Enabling sustainable jurisdictional action
                                </li>
                                <li className="flex items-start">
                                    <span className="mr-3 text-black">•</span>
                                    Developing technology for forest policy and finance
                                </li>
                            </ul>
                            
                            <Button
                                onClick={handleReadReport}
                                className="bg-green hover:bg-green/90 text-black font-bold py-3 px-8 rounded-full transition-colors duration-200 inline-block font-body"
                            >
                                READ REPORT
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* MOBILE */}
            <div className="w-full md:hidden">
                <div className="mx-8">
                    {/* Mobile Header - Top of gray box */}
                    <div className="rounded-t-lg p-8 text-center text-2xl font-bold text-black" style={{ backgroundColor: '#E4E4E4' }}>
                        2025 Impact Report
                    </div>
                    
                    {/* Mobile Image */}
                    <div className="relative w-full py-8" style={{ backgroundColor: '#E4E4E4' }}>
                        <div className="flex w-full items-center justify-center">
                            <div className="cursor-pointer" onClick={handleReadReport}>
                                <img 
                                    src="https://ctrees-website.s3.us-west-2.amazonaws.com/website_images/impact2025_cover.png"
                                    alt="CTrees 2025 Impact Report Cover"
                                    className="max-w-xs max-h-48 object-contain rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200"
                                />
                            </div>
                        </div>
                    </div>
                    
                    {/* Mobile Text and Button - Bottom of gray box */}
                    <div className="rounded-b-lg p-8" style={{ backgroundColor: '#E4E4E4' }}>
                        <p className="text-2xl text-black mb-6">
                            This report highlights CTrees institutional achievements in the following areas:
                        </p>
                        
                        <ul className="text-2xl text-black mb-8 space-y-2">
                            <li className="flex items-start">
                                <span className="mr-3 text-black">•</span>
                                Driving innovation in carbon markets,
                            </li>
                            <li className="flex items-start">
                                <span className="mr-3 text-black">•</span>
                                Enabling sustainable jurisdictional action,
                            </li>
                            <li className="flex items-start">
                                <span className="mr-3 text-black">•</span>
                                Developing technology for forest policy and finance
                            </li>
                        </ul>
                        
                        <Button
                            onClick={handleReadReport}
                            className="bg-green hover:bg-green/90 text-black font-bold py-3 px-8 rounded-full transition-colors duration-200 inline-block font-body"
                        >
                            READ REPORT
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
